import React from 'react';
import {View, Platform} from 'react-native';
import Text from '../../elements/Text';
import {useTheme} from '../../../theme';
import styles from './styles';
import {EmptyReadings} from '../../../utils/SvgIcons';

const NoReadings = () => {
  const {colors} = useTheme();
  return (
    <View style={styles.container}>
      <EmptyReadings
        width={Platform.OS === 'web' ? 300 : 204}
        height={Platform.OS === 'web' ? 300 : 177}
      />
      <Text variation="Body1SemiBold" color={colors.textPrimary}>
        No Readings Available Yet
      </Text>
      <Text
        variation="Text1Regular"
        color={colors.textSecondary}
        style={styles.lowerText}>
        Start adding manual inputs or sync your glucose monitor device.
      </Text>
    </View>
  );
};

export default NoReadings;
